const indexItems = [
  { title: '动作大片', count: '2,386部', icon: 'ri-fire-line' },
  { title: '科幻巨制', count: '1,892部', icon: 'ri-rocket-2-line' },
  { title: '悬疑烧脑', count: '1,654部', icon: 'ri-search-eye-line' },
  { title: '喜剧佳作', count: '2,140部', icon: 'ri-emotion-laugh-line' },
  { title: '爱情经典', count: '1,720部', icon: 'ri-heart-line' },
  { title: '恐怖惊悚', count: '1,036部', icon: 'ri-ghost-line' },
  { title: '动画动漫', count: '2,558部', icon: 'ri-magic-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">
            分类索引
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            影视分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型快速浏览影视资源，找到您喜欢的电影电视剧类别
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {indexItems.map((item, i) => (
            <a key={i} href="#cards" className="group flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-accent-300/50 hover:bg-background-50 transition-all duration-200 no-underline">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-accent-600 transition-colors whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}